<div [formGroup]="parentFormGroup">
    <textarea #input
              [formControlName]="parentFormControlName"
              (focus)="focussed()"
              (change)="changed()"
              [maxlength]="maxLength"
              [rows]="rows"
              [placeholder]="placeHolder"
              matInput
              (keydown)="onKeyPressed($event.key)"
              style="text-align: left; border-bottom: 1px solid rgb(150, 150, 150); width: 100%;"
    ></textarea>
    <div *ngIf="maxLength > 0" class="text-right"
         style="font-size: 0.8em;">{{parentFormGroup.get(parentFormControlName).value?.length}} sur {{maxLength}}
        caractères
    </div>
</div>
